import { useState, useEffect } from "react";
import UserPic from "../assets/images/userPic.png";
import { useNavigate, Link as RouterLink, useParams } from "react-router-dom";
import { Navbar, Page, Loader } from "../components";
import * as ROUTES from "../constant/routes";
import { getOrderHistory, getAllThirdPartySellers } from "../assets/Js/script";
import moment from "moment";
import { DateSchema } from "yup";
import { ToastContainer, toast } from "react-toastify";


export default function TpsOrderHistory() {
  const [orders, setOrders] = useState([]);
  const [thirdParty, setThirdParty] = useState(null);
  const [detail, setDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const notify = (message) => toast(message);

  const navigate = useNavigate();

  const { order_id } = useParams();

  useEffect(() => {
    (async () => {
      const { response, error } = await getOrderHistory(
        "organisationId",
        order_id.split("=")[1]
      );
      if(response.status === "success") {
        setOrders(response.data);
      setIsLoading(false);
      }else{
        setIsLoading(false);
        notify(response?.message ? response?.message : "Something went wrong");
      }
     
    })();
  }, []);

  useEffect(() => {
    const thirdPartySeller = async () => {
      const {
        response: { data, status },
      } = await getAllThirdPartySellers();
      if (status === "success") {
        const id = order_id.split("=")[1];
        let value = data?.pcpDetail?.filter((elem, index) => {
          return elem.tpId == id;
        });
        let value2 = data?.publication?.Tparties?.filter((elem, index) => {
          return elem.id === id;
        });
        setThirdParty({ ...value[0] });
        setDetail({ ...value[0] });
      }
    };

    thirdPartySeller();
  }, []);


  function filterData(bookid) {
    const test = [];
    const id = order_id.split("=")[1];

    if (orders) {
      for (var i = 0; i < orders?.bookData?.length; i++) {
        for (var x = 0; x < orders?.orderIdGroup[bookid].length; x++) {
          if (
            orders?.bookData[i]?.parentId ===
            orders?.orderIdGroup[bookid][x]?.bookId
          ) {
            test.push(orders?.bookData[i]);
          } else console.log("not working!");
        }
      }
    }

    return test;
  }

  function getDate(id) {
    return orders.orderIdGroup[id][0].createdAt;
  }


  return (
    <Page>
      <Navbar />
      {isLoading ? (
        <Loader show={isLoading} />
      ) : (
        <>
          <div className="hidden lg:flex mb-12 items-center justify-between">
            <div className="w-[390px] mt-6 flex pb-4 border-b-1 border-solid border-[#c5c1c4]">
              <button
                onClick={() => navigate(ROUTES.USERS)}
                className={`text-secondary-dark transition-[border] duration-100 tracking-wide mr-[60px] outline-0 border-0 text-montserrat font-semibold text-[18px] px-2
              `}
              >
                Individual User
              </button>
              <button
                onClick={() => navigate(ROUTES.USERS)}
                className={`text-secondary-dark transition-[border] duration-100 tracking-wide mr-[60px] outline-0 border-0 text-montserrat font-semibold text-[18px] px-2`}
              >
                Organisations
              </button>
              {/* <button
                onClick={() => navigate(ROUTES.USERS)}
                className={`text-secondary-dark transition-[border] duration-100 tracking-wide outline-0 border-0 text-montserrat font-semibold text-[18px] px-2 text-tertiary-dark border-b-[1.1px] border-b-solid border-b-primary-dark
             `}
              >
                Third Party Seller
              </button> */}
            </div>
            {/* <button
            onClick={() =>
              setModals((prevState) => ({ ...prevState, addNew: true }))
            }
            className="font-semibold text-h5 text-tertiary-dark underline"
          >
            Add a new user
          </button> */}
          </div>
          <div
            className={`my-14 mt-8 block lg:hidden px-4 flex lg:hidden justify-between items-center w-screen `}
          >
            <h1 className=" flex items-center text-mobile-h1  lg:text-h1 text-tertiary-dark lg:text-heading text-left font-bold lg:font-semibold">
              <span onClick={() => navigate(-1)} className=" mr-3">
                <svg
                  width="12"
                  height="20"
                  viewBox="0 0 12 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.0491 2.5473L9.4174 0.924805L0.351562 9.9998L9.42656 19.0748L11.0491 17.4523L3.59656 9.9998L11.0491 2.5473Z"
                    fill="#702963"
                  />
                </svg>
              </span>
              Order History
            </h1>
            <div className="flex lg:hidden items-center">
              <button className="mr-5">
                <svg
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25.25 25.25L19.5104 19.5104M22.6111 12.0556C22.6111 17.8852 17.8852 22.6111 12.0556 22.6111C6.22588 22.6111 1.5 17.8852 1.5 12.0556C1.5 6.22588 6.22588 1.5 12.0556 1.5C17.8852 1.5 22.6111 6.22588 22.6111 12.0556Z"
                    stroke="#702963"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button>
                <svg
                  width="28"
                  height="24"
                  viewBox="0 0 28 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25.715 10.285H25.742C26.207 10.285 26.627 10.477 26.927 10.787C27.237 11.088 27.429 11.508 27.429 11.973V12.001V12.027C27.429 12.492 27.237 12.912 26.927 13.212C26.626 13.522 26.206 13.714 25.741 13.714H25.713H25.513L23.972 22.583C23.9068 22.9816 23.698 23.3426 23.385 23.598L23.382 23.6C23.092 23.849 22.712 24.001 22.297 24.001H5.13C4.715 24.001 4.335 23.849 4.043 23.598L4.045 23.6C3.73304 23.3466 3.52402 22.9883 3.457 22.592L3.456 22.582L1.915 13.713H1.687C1.222 13.713 0.802001 13.521 0.502001 13.211C0.342948 13.0572 0.216523 12.8729 0.130273 12.6691C0.044023 12.4653 -0.000282597 12.2463 1.35628e-06 12.025V11.997V11.971C1.35628e-06 11.506 0.192001 11.086 0.502001 10.786C0.803001 10.476 1.223 10.284 1.688 10.284H1.716H1.715L25.715 10.285ZM6.492 20.999C6.6042 20.9913 6.71365 20.9608 6.81357 20.9092C6.9135 20.8576 7.00179 20.786 7.073 20.699L7.074 20.698C7.14997 20.6136 7.20767 20.5145 7.24346 20.4068C7.27926 20.299 7.29238 20.185 7.282 20.072V20.075L6.853 14.503C6.84535 14.3908 6.81478 14.2814 6.76318 14.1814C6.71158 14.0815 6.64005 13.9932 6.553 13.922L6.552 13.921C6.46765 13.845 6.36848 13.7873 6.26075 13.7515C6.15302 13.7157 6.03905 13.7026 5.926 13.713H5.929C5.8168 13.7207 5.70736 13.7512 5.60743 13.8028C5.5075 13.8544 5.41921 13.926 5.348 14.013L5.347 14.014C5.27103 14.0984 5.21333 14.1975 5.17754 14.3052C5.14174 14.413 5.12862 14.527 5.139 14.64V14.637L5.568 20.209C5.58227 20.425 5.68064 20.6267 5.842 20.771L5.843 20.772C5.99738 20.9185 6.20215 21.0002 6.415 21H6.426H6.425L6.492 20.999ZM11.997 20.143V14.571V14.563C11.9973 14.4519 11.975 14.3419 11.9313 14.2398C11.8876 14.1377 11.8235 14.0455 11.743 13.969C11.6662 13.8885 11.5739 13.8245 11.4716 13.7808C11.3693 13.7372 11.2592 13.7148 11.148 13.715H11.132C11.0209 13.7147 10.9109 13.737 10.8088 13.7807C10.7067 13.8244 10.6145 13.8885 10.538 13.969C10.4575 14.0458 10.3935 14.1381 10.3498 14.2404C10.3062 14.3427 10.2838 14.4528 10.284 14.564V20.152C10.284 20.386 10.381 20.597 10.538 20.746C10.6148 20.8265 10.7071 20.8905 10.8094 20.9342C10.9117 20.9778 11.0218 21.0002 11.133 21H11.149C11.2601 21.0003 11.3701 20.978 11.4722 20.9343C11.5743 20.8906 11.6665 20.8265 11.743 20.746C11.8246 20.6692 11.8895 20.5766 11.9339 20.4737C11.9783 20.3709 12.0011 20.26 12.001 20.148V20.142L11.997 20.143ZM17.14 20.143V14.571V14.563C17.1403 14.4519 17.118 14.3419 17.0743 14.2398C17.0306 14.1377 16.9665 14.0455 16.886 13.969C16.8092 13.8885 16.7169 13.8245 16.6146 13.7808C16.5123 13.7372 16.4022 13.7148 16.291 13.715H16.275C16.1639 13.7147 16.0539 13.737 15.9518 13.7807C15.8497 13.8244 15.7575 13.8885 15.681 13.969C15.6005 14.0458 15.5365 14.1381 15.4928 14.2404C15.4492 14.3427 15.4268 14.4528 15.427 14.564V20.152C15.427 20.386 15.524 20.597 15.681 20.746C15.7578 20.8265 15.8501 20.8905 15.9524 20.9342C16.0547 20.9778 16.1648 21.0002 16.276 21H16.292C16.4031 21.0003 16.5131 20.978 16.6152 20.9343C16.7173 20.8906 16.8095 20.8265 16.886 20.746C16.9676 20.6692 17.0325 20.5766 17.0769 20.4737C17.1213 20.3709 17.1441 20.26 17.144 20.148V20.142L17.14 20.143ZM21.854 20.209L22.283 14.637C22.2927 14.5243 22.2792 14.4108 22.2435 14.3035C22.2077 14.1962 22.1504 14.0973 22.075 14.013L22.076 14.014C22.005 13.9268 21.9169 13.8551 21.8172 13.8032C21.7174 13.7512 21.6081 13.7202 21.496 13.712H21.493C21.3803 13.7023 21.2668 13.7158 21.1595 13.7515C21.0522 13.7873 20.9534 13.8446 20.869 13.92L20.87 13.919C20.7828 13.99 20.7111 14.0781 20.6592 14.1778C20.6072 14.2776 20.5762 14.3869 20.568 14.499V14.502L20.139 20.074C20.1293 20.1867 20.1428 20.3002 20.1786 20.4075C20.2143 20.5148 20.2716 20.6137 20.347 20.698L20.346 20.697C20.417 20.7842 20.5051 20.8559 20.6048 20.9078C20.7046 20.9598 20.8139 20.9908 20.926 20.999H21.006C21.2191 20.999 21.4241 20.9174 21.579 20.771C21.7424 20.6269 21.8426 20.4243 21.858 20.207V20.204L21.854 20.209ZM6.376 3.909L5.131 9.427H3.363L4.715 3.521C4.878 2.736 5.305 2.071 5.897 1.606L5.904 1.601C6.49976 1.11788 7.24397 0.85509 8.011 0.857001H8.049H8.047H10.283V0.849001C10.283 0.615001 10.38 0.404001 10.537 0.255001C10.6138 0.174269 10.7063 0.110026 10.8088 0.0661855C10.9112 0.0223455 11.0216 -0.000173409 11.133 1.00545e-06H16.295C16.529 1.00545e-06 16.74 0.097001 16.889 0.254001C16.9695 0.330769 17.0335 0.423105 17.0772 0.525393C17.1208 0.627681 17.1432 0.737783 17.143 0.849001V0.857001H19.416C20.217 0.857001 20.952 1.137 21.528 1.605L21.522 1.6C22.1286 2.07342 22.5483 2.74605 22.707 3.499L22.711 3.52L24.063 9.426H22.295L21.05 3.908C20.9595 3.52933 20.7465 3.19115 20.444 2.946L20.441 2.943C20.1467 2.69994 19.7767 2.56731 19.395 2.568H17.14V2.576C17.1403 2.68709 17.118 2.79707 17.0743 2.89921C17.0306 3.00135 16.9665 3.09349 16.886 3.17C16.8092 3.25048 16.7169 3.31449 16.6146 3.35816C16.5123 3.40183 16.4022 3.42423 16.291 3.424H11.133C11.0219 3.42432 10.9119 3.40196 10.8098 3.35829C10.7077 3.31461 10.6155 3.25054 10.539 3.17C10.4585 3.09323 10.3945 3.0009 10.3508 2.89861C10.3072 2.79632 10.2848 2.68622 10.285 2.575V2.567H8.03C7.64739 2.56657 7.27666 2.69993 6.982 2.944L6.985 2.942C6.68473 3.18519 6.47283 3.52043 6.382 3.896L6.38 3.908L6.376 3.909Z"
                    fill="#702963"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row justify-between lg:w-full">
            <div className="flex  flex-col gap-y-5">
              <div className="flex  flex-col justify-evenly items-center bg-primary-white lg:bg-primary-extra-light border-primary-dark-20 lg:border-1 border-solid w-263 lg:h-205 lg:mr-4 mx-auto lg:mx-0">
                <p className="text-[14px] lg:text-p1 text-secondary-light mb-3 lg:mb-0">
                  Organization Name
                </p>
                <div className={`bg-[#bb7aaf] flex justify-center items-center w-24 h-24 rounded-full`}>
                  {thirdParty?.thirdPartyPhoto ? (
                    <img src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/portals/${thirdParty?.thirdPartyPhoto}`} alt="img" />
                  ) : (
                    <span
                      className={`text-[50px] uppercase font-bold text-[#fff]`}
                    >
                      {thirdParty?.fullName[0]}
                    </span>
                  )}
                </div>
                <h2 className="text-p1 mt-3 lg:mt-0 lg:text-h2 text-heading font-semibold">
                  {thirdParty?.fullName}
                </h2>
                <RouterLink
                  to="organization-details"
                  className="mt-2 lg:hidden leading-[19px] text-p1 text-tertiary-dark underline font-semibold text-center"
                >
                  View details
                </RouterLink>
              </div>
              <div className=" hidden lg:flex pl-8 flex-col py-4  items-start bg-primary-extra-light border-primary-dark-20 border-1 border-solid w-263  mr-4">
                <div className="flex mb-6">
                  <svg
                    style={{ marginTop: "3px" }}
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.59338 3.66699C4.92532 3.66699 4.28463 3.92222 3.81224 4.37653C3.33985 4.83084 3.07446 5.44702 3.07446 6.08951V6.33298L10.6312 10.2466L18.188 6.33419V6.08951C18.188 5.44702 17.9226 4.83084 17.4502 4.37653C16.9778 3.92222 16.3371 3.66699 15.6691 3.66699H5.59338Z"
                      fill="#7D7C7C"
                    />
                    <path
                      d="M18.188 7.70898L10.9297 11.4675C10.838 11.515 10.7354 11.5399 10.6312 11.5399C10.527 11.5399 10.4245 11.515 10.3327 11.4675L3.07446 7.70898V13.3571C3.07446 13.9996 3.33985 14.6158 3.81224 15.0701C4.28463 15.5244 4.92532 15.7796 5.59338 15.7796H15.6691C16.3371 15.7796 16.9778 15.5244 17.4502 15.0701C17.9226 14.6158 18.188 13.9996 18.188 13.3571V7.70898Z"
                      fill="#7D7C7C"
                    />
                  </svg>

                  <div className="ml-1 flex justify-between flex-col">
                    <h4 className="text-p1 font-semibold">Email address</h4>
                    <p className="text-s text-secondary-light font-semibold">
                      {detail?.email}
                    </p>
                  </div>
                </div>
                <div className="flex">
                  <svg
                    style={{ marginTop: "3px" }}
                    width="20"
                    height="22"
                    viewBox="0 0 20 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.3823 15.3398L13.1317 12.206C12.978 12.0579 12.7761 11.9789 12.5685 11.9857C12.361 11.9925 12.1641 12.0846 12.0193 12.2424L10.1058 14.3291C9.64515 14.2358 8.71915 13.9297 7.76596 12.9216C6.81277 11.9101 6.52409 10.9257 6.43853 10.4407L8.40489 8.41086C8.55395 8.2575 8.64089 8.04866 8.64731 7.82854C8.65373 7.60841 8.57912 7.39428 8.43927 7.23145L5.48454 3.78566C5.34463 3.62232 5.15019 3.52324 4.94249 3.50947C4.7348 3.49569 4.53023 3.56831 4.37222 3.71189L2.63696 5.2898C2.49871 5.43692 2.41619 5.63273 2.40506 5.84008C2.39307 6.05205 2.16436 11.0732 5.83639 14.9684C9.03981 18.3641 13.0525 18.6126 14.1576 18.6126C14.3192 18.6126 14.4183 18.6075 14.4447 18.6058C14.6402 18.5942 14.8248 18.5063 14.9629 18.3591L16.4502 16.5183C16.5862 16.3513 16.6552 16.1346 16.6425 15.9144C16.6298 15.6942 16.5364 15.4879 16.3823 15.3398Z"
                      fill="#7D7C7C"
                    />
                  </svg>

                  <div className="ml-1 flex justify-between flex-col">
                    <h4 className="text-p1 font-semibold">Phone number</h4>
                    <p className="text-s text-secondary-light font-semibold">
                      {detail?.mobile}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex mt-8 lg:mt-0 flex-col justify-between px-6 py-4  lg:bg-primary-extra-light border-primary-dark-20 lg:border-1 border-solid lg:w-[calc(100%-280px)] lg:max-w-921 ">
              <h2 className="text-h4  font-semibold text-secondary-dark">
                Order history
              </h2>
              <div className="my-8 lg:my-4">
                {orders.mySet.map((item) => (
                  <div
                    key={item}
                    className="mb-8 lg:mb-4 p-4 border-1 border-primary-dark-10 bg-primary-white "
                  >
                    <div className="flex justify-between items-center">
                      <div className="flex flex-col items-start">
                        <h3 className=" text-secondary-dark text-p1 lg:text-h4 text-montserrat font-semibold">
                          Order Id: <span className="uppercase">{item}</span>
                        </h3>
                        <p className="text-[14px] lg:text-h5 text-secondary-light">
                          {moment(getDate(item)).format("DD MMMM, YYYY")}

                        </p>
                      </div>
                    </div>
                    <div className="my-4 flex gap-x-4 overflow-x-scroll overflow-y-hidden">
                      {filterData(item).map((item, index) => {
                        return (
                          <div className=" bg-neutral-0 justify-between rounded-[10px] lg:p-4 flex w-[223px] h-[96px] lg:w-[266px] lg:h-[134px]">
                            <div style={{ background: item?.backgroundColor }} className="flex justify-center items-center  bg-neutral-50 w-[73px] p-2 pr-0 lg:p-0 lg:w-[80px] h-[96px] lg:h-[107px] mr-3 bg-[#A93030] ">
                              {item?.imageCoverFront && <img
                                src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/books/${item?.imageCoverFront}`}
                                alt="Cover photo"
                                className="h-full object-cover w-[55.5px] h-[77.8px] "
                              />}
                            </div>
                            <div className="flex flex-col w-[150px] py-[5px] lg:py-0 lg:w-[calc(100%-92px)] justify-between">
                              <p className="text-secondary-light text-medium text-[14px] uppercase">

                              </p>
                              <p className="text-left text-heading-false font-semibold text-[16px] leading-[19px] lg:text-[15px] ">
                                {item?.title}
                              </p>
                              <p className="text-montserrat text-[14px] lg:text-[13px] font-semibold text-secondary-dark">
                                {item.Bauthors?.map(
                                  (auther, index, arr) => <span>{
                                    (arr.indexOf(arr[index]) === arr.length - 1) ? auther.bookAuthorName : `${auther.bookAuthorName}, `
                                  }</span>
                                )}                               </p>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                    <div className="text-right mb-2">
                      <button
                        onClick={() => navigate(`order-details=${item}`)}
                        className="underline text-tertiary-dark font-bold"
                      >
                        View More
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
      <ToastContainer
            position="top-right"
            autoClose={3000}
            closeOnClick
            pauseOnFocusLoss
            pauseOnHover
          />
    </Page>
  );
}
